import { RefreshCw } from 'lucide-react'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { OverviewTab } from '../components/OverviewTab'
import { VisitadoresTab } from '../components/VisitadoresTab'
import { DependientesTab } from '../components/DependientesTab'
import { TriviasTab } from '../components/TriviasTab'

export function ReporteAnalyticsDifarePage() {
  return (
    <div className="p-4 space-y-5">
      {/* Header */}
      <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <h1 className="text-xl font-bold">Difare Expertos · Analytics</h1>
        <span className="flex items-center gap-1 text-xs text-muted-foreground">
          <RefreshCw className="h-3 w-3" /> datos en vivo
        </span>
      </div>

      {/* Secciones */}
      <Tabs defaultValue="overview" className="space-y-4">
        <TabsList>
          <TabsTrigger value="overview">Resumen</TabsTrigger>
          <TabsTrigger value="visitadores">Visitadores</TabsTrigger>
          <TabsTrigger value="dependientes">Dependientes</TabsTrigger>
          <TabsTrigger value="trivias">Trivias</TabsTrigger>
        </TabsList>
        <TabsContent value="overview">
          <OverviewTab />
        </TabsContent>
        <TabsContent value="visitadores">
          <VisitadoresTab />
        </TabsContent>
        <TabsContent value="dependientes">
          <DependientesTab />
        </TabsContent>
        <TabsContent value="trivias">
          <TriviasTab />
        </TabsContent>
      </Tabs>
    </div>
  )
}
